export default "__VITE_ASSET__B07PjH8K__"